/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ReorderIcon = ({ width = 24, height = 24, hidden = false, title = 'Reorder' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M18 4a.994.994 0 0 0-.747.336l-11 10a.979.979 0 0 0-.253.658A1 1 0 0 0 7 16h22a1 1 0 0 0 1-1.006.979.979 0 0 0-.255-.658l-11-10A1 1 0 0 0 18 4ZM18 32a1 1 0 0 0 .747-.336l11-10a.979.979 0 0 0 .253-.658A1 1 0 0 0 29 20H7a1 1 0 0 0-1 1.006.979.979 0 0 0 .255.658l11 10A.994.994 0 0 0 18 32Z"
    />
  </svg>`;
};
